import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {
    Button,
    Box,
    Text,
    SimpleGrid,
    VStack
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {
    ADD_FILTER,
    REMOVE_FILTER
} from '@salesforce/retail-react-app/app/pages/product-list/partials/refinements-utils'
import {pxToRem} from '../../../utills/pxToRem'
import {iconTitleStyle} from './refinements.style'

const IconRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const {formatMessage} = useIntl()

    return (
        <Box>
            <SimpleGrid columns={3} spacingY={{base: '10px', md: '15px'}}>
                {filter.values?.map((value, idx) => {
                    // Note the loose comparison, for "string == number" checks.
                    const isSelected = selectedFilters.some(
                        (filterValue) => filterValue == value.value
                    )
                    // Don't display refinements with no results, unless we got there by selecting too
                    // many refinements
                    if (value.hitCount === 0 && !isSelected) return

                    return (
                        <VStack
                            key={idx}
                            onClick={() => toggleFilter(value, filter.attributeId, isSelected)}
                            cursor="pointer"
                        >
                            <Button
                                key={idx}
                                backgroundColor={'white'}
                                color={'black'}
                                aria-checked={isSelected}
                                display={'flex'}
                                flexDirection={'column'}
                                padding={0}
                                marginBottom={pxToRem(10)}
                                aria-label={formatMessage(
                                    isSelected ? REMOVE_FILTER : ADD_FILTER,
                                    value
                                )}
                                sx={
                                    isSelected
                                        ? {
                                              backgroundColor: 'transparent',
                                              '.imageWrapper': {
                                                  backgroundColor: 'black',
                                                  borderRadius: '100%'
                                              },
                                              img: {
                                                  filter: 'brightness(0) invert(1)'
                                              }
                                          }
                                        : {}
                                }
                                _hover={{
                                    backgroundColor: 'transparent',
                                    '.imageWrapper': {
                                        backgroundColor: 'black',
                                        borderRadius: '100%'
                                    },
                                    img: {
                                        filter: 'brightness(0) invert(1)'
                                    }
                                }}
                            >
                                <Box marginTop={pxToRem(15)} className="imageWrapper">
                                    <img
                                        src={getAssetUrl(
                                            `static/img/plp/${value.label.toLowerCase()}-toe.png`
                                        )}
                                        height="30px"
                                        width="30px"
                                        alt="${value.label}"
                                    />
                                </Box>
                            </Button>
                            <Text sx={iconTitleStyle}>{value.label}</Text>
                        </VStack>
                    )
                })}
            </SimpleGrid>
        </Box>
    )
}

IconRefinements.propTypes = {
    filter: PropTypes.object,
    selectedFilters: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    toggleFilter: PropTypes.func
}

export default IconRefinements
